import { Injectable } from "@angular/core";

@Injectable()
export class ErrorMessageWithoutTypeService {
  public messageFor(err: any) {
    let msg = err.message;
    if (msg == null || msg === "") {
      return "<empty error message>";
    }
    if (err.type != null) {
      const type = err.type + ": ";
      if (msg.startsWith(type)) {
        msg = msg.slice(type.length);
      }
    }
    return msg;
  }
}
